import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
let PiHomeMmapScreenSta = class PiHomeMmapScreenSta extends Vue {
    constructor() {
        super(...arguments);
        this.staList = [];
        this.active = "";
        this.searchNameShow = false;
    }
    "watch.searchName"() {
        this.getStaList();
    }
    /**
     * 筛选站点
     */
    getStaList() {
        this.searchNameShow = true;
        let list = this.allList.filter((item) => {
            return (item.staName.indexOf(this.searchName) != -1 ||
                this.searchName == item.oprName);
        });
        if (list.length > 0) {
            this.active = list[0].staPkId;
        }
        this.staList = list;
        this.$emit("screen-sta-list", list);
    }
    /**
     * 站点点击
     */
    staClick(item) {
        this.active = item.staPkId;
        this.searchNameShow = false;
        this.$emit("screen-sta-click", item);
    }
    openSearch() {
        this.searchNameShow = true;
    }
    /**
     * 重置
     */
    reset() {
        this.active = "";
        this.searchName = "";
        this.searchNameShow = false;
        this.staList = [];
    }
};
__decorate([
    Prop({ default: "" })
], PiHomeMmapScreenSta.prototype, "searchName", void 0);
__decorate([
    Watch("searchName")
], PiHomeMmapScreenSta.prototype, "watch.searchName", null);
__decorate([
    Prop({
        default: () => {
            return [];
        },
    })
], PiHomeMmapScreenSta.prototype, "allList", void 0);
PiHomeMmapScreenSta = __decorate([
    Component({
        components: {},
    })
], PiHomeMmapScreenSta);
export default PiHomeMmapScreenSta;
